import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { API_URL } from "../../utils/config";
import API from "../../redux/api";

const initialState = {
  list: [],
  unreadCount: 0,
  isLoading: false,
};

console.log('initialState',initialState)

export const fetchNotifications = createAsyncThunk(
  "notifications/fetch",
  async () => {
    const res = await API.get("bankmanagement/fetch_unread_notifications/");
    return res.data;
  }
);

export const markNotificationReadAPI = createAsyncThunk(
  "notifications/markReadAPI",
  async (id) => {
    await API.patch(`bankmanagement/notifications/${id}/mark_read/`);
    return id;
  }
);


const notificationSlice = createSlice({
  name: "notifications",
  initialState,

  reducers: {

    addNotification: (state, action) => {
      const exists = state.list.some(n => n.id === action.payload.id);

      if (!exists) {
        state.list.unshift(action.payload);
        state.unreadCount += 1;
      }
    },

    resetNotifications: () => initialState,
  },


  extraReducers: (builder) => {

    builder

      // FETCH
      .addCase(fetchNotifications.pending, (state) => {
        state.isLoading = true;
      })
      
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload || [];
        state.unreadCount = action.payload.length || 0;
        console.log('redux?',action.payload); // <-- res.data
      })

      .addCase(fetchNotifications.rejected, (state) => {
        state.isLoading = false;
      })


      // MARK READ SUCCESS
      .addCase(markNotificationReadAPI.fulfilled, (state, action) => {
        const id = action.payload;

        const notif = state.list.find(n => n.id === id);
        if (notif && !notif.is_read) {
          notif.is_read = true;
          state.unreadCount -= 1;
        }
      });
  },
});

export const { addNotification, resetNotifications } =
  notificationSlice.actions;

export default notificationSlice.reducer;
